// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hb","advertCardHeader__actions":"c-a_hc","advertCardHeader__bottomLabel":"c-a_he"};